import axios from 'axios';
import { FishGroup } from '../types/fish-group.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/{fishGroupId}
export const getFishGroup = async (globalSiteId: string, fishGroupId: string): Promise<FishGroup> => {
  const res = await axios.get<FishGroup>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/${fishGroupId}`);
  return res.data;
};

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/{fishGroupId}/inactive
export const getInactiveFishGroup = async (globalSiteId: string, fishGroupId: string): Promise<FishGroup> => {
  const res = await axios.get<FishGroup>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/${fishGroupId}/inactive`);
  return res.data;
};
